import { render, staticRenderFns } from "./Contradiction.vue?vue&type=template&id=0659af6d&scoped=true&"
import script from "./Contradiction.vue?vue&type=script&lang=js&"
export * from "./Contradiction.vue?vue&type=script&lang=js&"
import style0 from "./Contradiction.vue?vue&type=style&index=0&id=0659af6d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0659af6d",
  null
  
)

export default component.exports